import { css } from 'styled-components'

export const linkStyle = css`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.font.link};
  cursor: pointer;
  transition: 0.3s;
  background: none;
  border: none;
  &:hover {
    text-decoration: underline;
  }
`
